import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/utils.js';
// The multi-line sibling of Input, same seam: no invalid border state — errors
// are a <FormError/> line next to the field. Height is free-form (rows), so it
// deliberately does NOT follow --control-height.
export const Textarea = React.forwardRef(({ className, rows = 4, ...props }, ref) => (_jsx("textarea", { ref: ref, rows: rows, className: cn('w-full resize-y rounded-md border border-input bg-card px-3 py-2 text-sm text-foreground shadow-xs outline-none transition-colors placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50', className), ...props })));
Textarea.displayName = 'Textarea';
